/*
 * @Descripttion: 
 * @version: 
 * @Author: zj
 * @Date: 2020-07-22 13:58:40
 * @LastEditors: zj
 * @LastEditTime: 2020-7-23 18:15:33
 */ 
import axios from '../axios'

/* 
 * 消息预警模块
 */

 //获取消息列表
 export const getMessageList = (data) => {
    return axios({
        url: '/admin/service/getMessageList',
        method: 'post',
        data
    })
}
//获取消息总数
export const sys_message_list = (data) => {
    return axios({
        url: '/admin/service/sys_message_list',
        method: 'post',
        data
    })
}

// 改变阅读状态
export const changeStatus = (data) => {
    return axios({
        url: '/admin/service/readMessage',
        method: 'post',
        data
    })
}

// 删除
export const deleteData = (data) => {
    return axios({
        url: '/admin/service/delMessage',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/message.js